import { Component, inject } from '@angular/core';
import {
	SCHEDULE_DETAIL_KIND,
	ScheduleDetailFacade,
	type ScheduleDetailKind,
} from 'src/app/facades/schedule-detail.facade';

@Component({
	standalone: false,
	selector: 'app-parents',
	templateUrl: './parents.component.html',
	styleUrls: ['./parents.component.scss'],
	providers: [{ provide: SCHEDULE_DETAIL_KIND, useValue: 'parents' satisfies ScheduleDetailKind }, ScheduleDetailFacade],
})
export class ParentsComponent {
	protected readonly facade = inject(ScheduleDetailFacade);

	constructor() {
		this.facade.start();
	}
}
